// eslint-disable-next-line import/no-cycle
import {

    PETTY_CASH_LOAD_PETTY_CASH_TOPBAR,
    PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS,

} from '../actions';

// // -------------------- PettyCashTopList --------------------- //

export const getPettyCashTopbarData = (data, token) => ({
    type: PETTY_CASH_LOAD_PETTY_CASH_TOPBAR,
    payload: data,
    token
});
export const getPettyCashTopbarDataSuccess = (data, dataList, token) => ({
    type: PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS,
    payload: data,
    payloadList: dataList,
    token
});



